/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Payments_Tab_HistoryInputs */

const en_my_payments_tab_history = /** @type {(inputs: My_Payments_Tab_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payments`)
};

const pl_my_payments_tab_history = /** @type {(inputs: My_Payments_Tab_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Płatności`)
};

/**
* | output |
* | --- |
* | "Payments" |
*
* @param {My_Payments_Tab_HistoryInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const my_payments_tab_history = /** @type {((inputs?: My_Payments_Tab_HistoryInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Payments_Tab_HistoryInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_my_payments_tab_history(inputs)
	return en_my_payments_tab_history(inputs)
});